import { useTranslation } from 'react-i18next'
import '../../style/components/empty.css'

export default function Empty (props) {
    const { t } = useTranslation();
    const StyleEmpty = () => {
        if(props.mode === 'employee') {
            return {
                height: "350px"
            }
        }
        else {
            return {
                height: '90vh',
                width: "100%"
            }
        }
    }
    return (
        <div style={StyleEmpty()} className="empty flex flex-center-center">
            <div className="empty-container center">
                <h2>{t("common:empty.head")}</h2>
                <p>{t("common:empty.body")}</p>
            </div>
        </div>
    )
}